import config from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagementsDemo.config'
import SkyNetObjectProfile from '../components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from '../components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const EngagementsDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={config}
            featuresLists={featuresLists}
        />
    )
}

export default EngagementsDemoPage
